import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=139c2964&scoped=true&"
var script = {}
import style0 from "./logo.vue?vue&type=style&index=0&id=139c2964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139c2964",
  null
  
)

export default component.exports